// extracted by mini-css-extract-plugin
export default {"label":"Verbrauch_label__2vOOj","input":"Verbrauch_input__rH1Mf"};